
import vector1 from './assets/Vector1.png';
import vector2 from './assets/Vector2.png';
import vector3 from './assets/Vector3.png';
import vector4 from './assets/Vector4.png';
import vector5 from './assets/Vector5.png';
import cvector1 from './assets/cVector1.png';
import cvector2 from './assets/cVector2.png';
import cvector3 from './assets/cVector3.png';
import cvector4 from './assets/cVector4.png';

export const infoCardData = [
  {
    image: vector1,
    heading: 'Candidates Evaluated',
    discription: '5,000+'
  },
  {
    image: vector5,
    heading: 'Happy Clients',
    discription: '100+'
  },
  {
    image: vector4,
    heading: 'Successful Placements',
    discription: '400+'
  },
  {
    image: vector2,
    heading: 'Training Programs Delivered',
    discription: '50+'
  },

]

export const courseInfoCardData = [
  {
    image: cvector1,
    heading: 'Skill Level',
    discription: 'Intermediate'
  },
  {
    image: cvector2,
    heading: 'Time to Complete',
    discription: '< 1 Hour'
  },
  {
    image: cvector3,
    heading: 'Certificate Of Completion',
    discription: 'Included With Paid Courses'
  },
  {
    image: cvector4,
    heading: 'Prerequiesites',
    discription: 'None'
  },
]

const departmentsFaq = [
  {
    question: 'What courses does AshreiTech Academy offer?',
    answer: 'AshreiTech Academy offers training in a range of high-tech skills, including:\n' +
      'SAP: Covering SuccessFactors Employee Central, FICO, Customer Experience, and Ariba Strategic Sourcing.\n' +
      'Salesforce: Focusing on both Administrator and Associate levels.\n' +
      'Cybersecurity: Specializing in Security Operations Center (SOC) and Vulnerability Assessment and Penetration Testing (VAPT).\n' +
      'Our programs are designed to equip you with the knowledge and hands-on experience needed to excel in these advanced technological fields.\n'
  },
  {
    question: 'What is the duration of the training programs?',
    answer: 'The training programs last for 3 months.'
  },
  {
    question: 'What are the class timings and schedule?',
    answer: 'Classes are held in the evenings and can be either 3 days a week or 2 days a week, each session lasting 2 hours. The specific days depend on the schedule of each training program.'
  },
  {
    question: 'Who are the experts at AshreiTech Academy?',
    answer: ' Our training experts are professionals from various organizations who are experienced in their respective fields.'
  },
  {
    question: ' Does AshreiTech Academy provide job placement assistance?',
    answer: 'Yes, after completing 3 months of training, we connect our trained graduates with employers and organizations to help them secure jobs.'
  },
  {
    question: ' Where is AshreiTech Academy located?',
    answer: ' We are located in Karachi and Lahore.\n ' +
      'Karachi: 2nd Floor, National Aerospace Science and Technology Park, Faisal Base, Main Shahrah e Faisal Road, Karachi.\n' +
      'Lahore: 69, Abid Majeed Road (Old airport Building), NASTP Delta, Lahore Cantonment.\n'
  },
  {
    question: 'Are the SAP and Salesforce trainings conducted on instances?',
    answer: ' Yes, for SAP and Salesforce, we work on instances to provide hands-on experience.'
  },
  {
    question: 'What are the prerequisites for enrolling in a course?',
    answer: 'Prerequisites vary depending on the course. Generally, a basic understanding of the relevant field is beneficial. For specific requirements, please refer to the course details on our website or contact us directly.'
  },
  {
    question: 'How can I enrol in a course at AshreiTech Academy?',
    answer: ' You can enrol by visiting our website and filling out the enrolment form, or you can visit our academy in person for assistance.'
  },
  {
    question: 'What is the fee structure for the courses?',
    answer: ' The fee structure varies for each course. Please visit our website or contact our admissions office for detailed information on course fees.'
  },
  {
    question: 'What if I miss a class?',
    answer: 'If you miss a class, our trainers will help you catch up. You can also reach out to the admin for any specific queries.'
  },
  {
    question: 'Do I receive a certification upon completion of the course?',
    answer: ' Yes, upon successful completion of the course and assessments, you will receive a certification from AshreiTech Academy.'
  },



]


export default departmentsFaq